// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ib_l","inner":"Footer_inner__2d78d"};